import { el, escape } from './dom';
import type { BlogPost as BlogPostData } from '../blog/posts';

export type BlogPostProps = {
  post: BlogPostData;
};

const formatDate = (iso: string): string => {
  const d = new Date(`${iso}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  });
};

export const BlogPost = (props: BlogPostProps): HTMLElement => {
  const { post } = props;
  return el(`
    <article class="blog-post">
      <div class="container">
        <a class="blog-back" href="/blog">← all posts</a>
        <header class="blog-post-header">
          <div class="blog-meta mono">
            <time datetime="${escape(post.publishedOn)}">${escape(formatDate(post.publishedOn))}</time>
            <span class="dot">·</span>
            <span>${escape(post.readingTime)}</span>
          </div>
          <h1>${escape(post.title)}</h1>
          <p class="blog-lede">${escape(post.lede)}</p>
        </header>
        <div class="blog-prose">${post.bodyHtml}</div>
      </div>
    </article>
  `);
};
